import { ApmBase } from '@elastic/apm-rum';

const apmState: { apm: ApmBase | undefined } = {
  apm: undefined,
};

export function captureError(error: unknown): void {
  return apmState.apm?.captureError(error as Error | string);
}

export function setApm(apm: ApmBase): void {
  apmState.apm = apm;
}
